import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function formDate(date: string | null): Date | null {
  return !!date && date !== null && date !== "" ? new Date(date as unknown as string) : null;
}

export const InputCell = ({
  name,
  value,
  onChange,
  trailingText,
  inputType = "text",
  disabled,
}: {
  name: string;
  value: string | number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  trailingText?: string;
  inputType?: React.HTMLInputTypeAttribute;
  disabled: boolean | undefined;
}) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge("flex items-center")}>
      <input
        disabled={disabled}
        name={name}
        type={inputType}
        value={value}
        onChange={onChange}
        className={twMerge(
          "w-full border px-2 py-3.5 focus:outline-none focus:ring",
          trailingText ? "rounded-s-md" : "rounded-md",
        )}
      />
      {trailingText && (
        <span
          className={twMerge(
            "whitespace-nowrap rounded-e-md border border-l-0 px-2 py-3.5 text-center",
            theme.uwhcAssistant.border,
            theme.uwhcAssistant.tableBg,
            theme.uwhcAssistant.theadText,
          )}
        >
          {trailingText}
        </span>
      )}
    </div>
  );
};
